import { queryRole } from 'liyu-pc-base/api/permission/role-manage';
import { useUserStore } from 'liyu-pc-base/init-plugin';

export default () => {
  const userStore = useUserStore();
  const org = userStore.currentOrg;
  const search_config: any = {
    model: {
      org_id: org?.id,
      aim_org_id: org?.id,
      is_active: true,
      page_index: 1,
      page_size: 2000,
    },
    watch: ['aim_org_id'],
  };
  return {
    getData: queryRole,
    searchConfig: search_config,
  };
};
